module.exports = __webpack_public_path__ + "img/banner.8bdcf550.svg";